export default {
  Customers: 'Pelanggan',
}
